module.exports = __webpack_public_path__ + "static/img/ratio1.09c4212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2-coupon/ratio1.png
// module id = w4dj
// module chunks = 12